import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { type VerifyV3CheckResponse, verifyV3Check } from '@/api/generated';

type MutationParams = {
  phoneNumber: string;
  code: string;
};

function useSmsVerifyCodeMutation(
  options?: UseMutationOptions<VerifyV3CheckResponse, Error, MutationParams>
) {
  return useMutation({
    mutationFn: async (params) => {
      const { data } = await verifyV3Check({
        body: {
          phone_number: params.phoneNumber,
          code: params.code,
        },
      });

      return data;
    },
    ...options,
  });
}

export { useSmsVerifyCodeMutation };
